// 禁用结束时间早于开始时间的日期
export function disabledEndDate (time, startTime) {
    if (!startTime) return false; // 未选择开始时间时不限制
    // 比较日期部分，忽略时间
    const startDate = new Date(startTime);
    startDate.setHours(0, 0, 0, 0); // 归零时间部分

    const selectedDate = new Date(time);
    selectedDate.setHours(0, 0, 0, 0); // 归零时间部分

    // 禁用早于开始日期的日期
    return selectedDate.getTime() < startDate.getTime();
}
